import messages from './ar/messages.json';

const normalize = value => value.replace(/\s+/g, ' ').trim();
const entries = Object.entries(messages);
const masterLabels = new Map();
export function rememberMasterLabels(data) {
  if (!data || typeof data !== 'object') return;
  if (typeof data.name === 'string' && typeof data.name_ar === 'string' && data.name_ar.trim()) {
    masterLabels.set(normalize(data.name).toLowerCase(), data.name_ar);
  }
  Object.values(data).forEach(value => {
    if (value && typeof value === 'object') rememberMasterLabels(value);
  });
}
const lookup = new Map(entries.map(([key, value]) => [normalize(key).toLowerCase(), value]));
const patterns = entries.filter(([key]) => /\{\d+\}/.test(key))
  .sort(([a], [b]) => b.replace(/\{\d+\}/g, '').length - a.replace(/\{\d+\}/g, '').length)
  .map(([key, value]) => ({
  regex: new RegExp('^' + normalize(key).split(/(\{\d+\})/).map(part => /\{\d+\}/.test(part) ? '(.*?)' : part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('') + '$', 'i'),
  slots: [...key.matchAll(/\{(\d+)\}/g)].map(match => match[1]),
  value,
}));

// Only call this for interface copy. User-authored names, addresses and listing
// content are rendered directly, and canonical form/API values are never changed.
export function translate(value, language = 'en', params) {
  if (typeof value !== 'string') return value;
  let result = value;
  if (language === 'ar') {
    const key = normalize(value);
    if (/^\d{1,2} [A-Za-z]{3} \d{4}$/.test(key)) {
      const date = new Date(key);
      if (!Number.isNaN(date.getTime())) return new Intl.DateTimeFormat('ar-SA-u-ca-gregory-nu-latn', {day:'2-digit', month:'short', year:'numeric'}).format(date);
    }
    result = messages[key] || lookup.get(key.toLowerCase()) || masterLabels.get(key.toLowerCase());
    if (!result) {
      for (const pattern of patterns) {
        const match = key.match(pattern.regex);
        if (match) {
          const captures = Object.fromEntries(pattern.slots.map((slot, index) => [slot, match[index + 1]]));
          result = pattern.value.replace(/\{(\d+)\}/g, (_, slot) => captures[slot] ?? '');
          break;
        }
      }
    }
    if (!result && /[,·]/.test(key)) {
      result = key.split(/(,\s*|\s*·\s*)/).map(part => lookup.get(part.toLowerCase()) || masterLabels.get(part.toLowerCase()) || part).join('');
    }
    if (result) result = (value.match(/^\s+/)?.[0] || '') + result + (value.match(/\s+$/)?.[0] || '');
    else result = value;
  }
  return params ? result.replace(/\{(\w+)\}/g, (match, key) => params[key] ?? match) : result;
}
